export const DATA_PACKAGE_HIERARCHY_ACCEPTED_FILE_TYPES = [
  ".csv",
  "text/csv",
  ".xlsx",
  ".xls",
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
  "application/vnd.ms-excel",
];
